export default "__VITE_ASSET__d3a385c2__"